<template>
    <div class="main-navbar bg-white sticky-top">
        <nav class="content-head align-items-stretch flex-md-nowrap p-0 navbar navbar-light">
            <form class="main-navbar__search w-100 d-none d-md-flex d-lg-flex">
                <div role="group" class="ml-3 input-group input-group-seamless">

                </div>
            </form>
            <div class="flex-row navbar-nav  notif-container">
                <Notifications @onLoggedOut="onLoggedOut"></Notifications>
            </div>
        </nav>
        <v-snackbar-queue top="top" class="flat" :timeout="messageTimeout" :items="message" @remove="removeItem"></v-snackbar-queue>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Notifications from "./Notifications";

    export default{
        name: 'Header',
        components: {Notifications},
        data(){
            return{
                message: this.getMessage ? this.getMessage : [],
                displaySnackbar: true,
                messageTimeout: 4000,
            }
        },
        computed: {
            ...mapGetters([
                'user',
                'getMessage'
            ]),
        },
        methods: {
            removeItem (id) {
                this.$store.commit('clearMessage');
            },
            onLoggedOut() {

            }
        },
        watch: {
            getMessage: function(newVal) {
                this.message = newVal;
            }
        },
        mounted() {
        }

    }
</script>

<style lang="scss">
    .content-head{
        box-shadow: 0 0.125rem 0.625rem rgba(90,97,105,.12);
        height: 60px;
    }
    .notif-container{
        margin-right: 4px;
        position: relative;
        left:-webkit-calc(100% - 270px);
        left:-moz-calc(100% - 270px);
        left:calc(100% - 270px);
        top: -6px;
        text-align: right;
    }
    @media (max-width: 767px) {
        .content-head{
            height: 0px;
        }
    }

    .v-snack__content {
        text-align: center !important;
    }
    .v-btn__content i {
        display: none;
    }
    .v-btn__content::before {
        font-family: "Font Awesome 5 Free";
        content: "\f057";
        font-size: 16px;
        padding: 5px;
        margin-top: 2px;
    }
</style>
